import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getNutritionTemplates } from '../services/nutrition';
import usePagination from './usePagination';

export const useNutritionTemplates = () => {
    const {
        paginationModel,
        setPaginationModel,
        rowsPerPageOptions,
        count,
        currentToken,
        resolveHeader
    } = usePagination();

    const fetchNutritionPlans = async ({ queryKey }) => {
        const [, { paginationModel }] = queryKey;
        return getNutritionTemplates(
            paginationModel.pageSize,
            currentToken(paginationModel.page)
        );
    };

    const { data, isPending, isError } = useQuery({
        queryKey: ['nutrition-templates', { paginationModel }],
        queryFn: fetchNutritionPlans,
        keepPreviousData: true
    });

    useEffect(() => {
        if (data) {
            resolveHeader(data.headers, paginationModel.page);
        }
    }, [data]);

    return {
        data: data?.data || [],
        isLoading: isPending,
        error: isError,
        count,
        rowsPerPageOptions,
        paginationModel,
        setPaginationModel
    };
};